import type { WorkspaceUsageDto } from '@/features/billing/types';

export type LiveRoleRow = {
  speakerId?: number;
  fullName?: string;
  jobTitle?: string;
  email?: string;
};

export function getLiveRolesMax(usage: WorkspaceUsageDto | null | undefined): number | null {
  const max = usage?.presenters?.max;
  if (max == null || max <= 0) return null;
  return max;
}

export function isSpeakerRowEmpty(row: LiveRoleRow): boolean {
  return (
    row.speakerId == null &&
    !(row.fullName?.trim() ?? '') &&
    !(row.jobTitle?.trim() ?? '') &&
    !(row.email?.trim() ?? '')
  );
}

export function countSpeakerFormRows(rows: LiveRoleRow[]): number {
  return rows.filter((row) => !isSpeakerRowEmpty(row)).length;
}

export function isLiveRolesAtMax(current: number, max: number | null): boolean {
  return max != null && current >= max;
}

export function wouldExceedLiveRolesLimit(
  presentersCount: number,
  guestsCount: number,
  max: number | null,
): boolean {
  if (max == null) return false;
  return presentersCount + guestsCount > max;
}
